import { LinkWithIcon } from '#shared/components/LinkWithIcon';
import { badgesRoute } from '#shared/lib/routes';

export const BadgeSettingsLinkBlock = () => (
    <>
        Управление бейджами — в разделе{' '}
        <LinkWithIcon href={badgesRoute.getUrl()} inline>
            Настройки → Бейджи
        </LinkWithIcon>
    </>
);
